<template>
  <transition mode="out-in" name="fade" v-if="slider">
    <div v-show="!loading" :class="classes.transitionWrapper">
      <component :is="slider">
        <div v-if="shouldDisplayOffer"><OfferCard /></div>
        <CardSelector
          v-for="marketIds in orderedMarkets"
          :key="marketIds[0]"
          :marketIds="marketIds"
        />
      </component>
    </div>
  </transition>
  <transition mode="out-in" name="fade" v-else>
    <div
      v-show="!loading"
      :class="classes.transitionWrapper"
      :style="{ overflow: 'hidden' }"
    >
      <OfferCard v-if="shouldDisplayOffer"></OfferCard>
      <CardSelector
        v-else-if="orderedMarkets.length > 0"
        :marketIds="orderedMarkets[0]"
      ></CardSelector>
    </div>
  </transition>
</template>

<script lang="ts">
import CardSelector from "./CardSelector.vue";
import { computed, defineAsyncComponent, defineComponent, ref } from "vue";
import { isTouchDevice } from "../lib/isTouchDevice";
import { provideCarouselContext } from "../lib/provideInjectors";
import OfferCard from "./offer/Wrapper.vue";
import { useShouldDisplayOffer } from "../hooks/useDisplayOffer";
import { watchEffect } from "vue";
import { injectBetDataRef } from "@fresh8/ad-data-composition/src/betData";
import { createUseStyles } from "@fresh8/vue-jss/src";
import { injectDisplayEvents } from "../composition/displayEvents";

const useStyles = createUseStyles({
  transitionWrapper: {
    flex: 1,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box"
  }
});

export default defineComponent({
  name: "Content",
  components: {
    CardSelector,
    OfferCard
  },
  setup() {
    const classes = useStyles();
    const { orderedMarkets } = injectDisplayEvents();
    const isTouch = isTouchDevice();
    const isCarousel = ref(false);
    const shouldDisplayOffer = useShouldDisplayOffer();
    const betDataContext = injectBetDataRef();

    provideCarouselContext(isCarousel);

    const slider = computed(() => {
      if (
        orderedMarkets.value.length > 1 ||
        (shouldDisplayOffer.value && orderedMarkets.value.length)
      ) {
        isCarousel.value = true;
        if (isTouch) {
          return defineAsyncComponent(() => import("./TouchSlider"));
        }
        return defineAsyncComponent(() => import("./Carousel"));
      }
      return false;
    });

    // If no markets and no offer then collapse the ad
    watchEffect(() => {
      if (orderedMarkets.value.length === 0 && !shouldDisplayOffer.value) {
        window.parent.postMessage({ type: "f8_failed_loading" }, "*");
        document.documentElement.style.height = "0px";
        document.documentElement.style.overflow = "hidden";
        document.body.style.height = "0px";
        document.body.style.overflow = "hidden";
      }
    });

    return {
      classes,
      slider,
      shouldDisplayOffer,
      orderedMarkets,
      loading: computed(() => betDataContext?.loading.value)
    };
  }
});
</script>
